const ENTER_KEY = 13
const SPACE_KEY = 32
const TAB_KEY = 9

module.exports = {
  ENTER_KEY,
  SPACE_KEY,
  TAB_KEY,
}
